<app-color-list-preview
  *ngFor="let coloredYarnSet of listOfColoredYarnSets; let index = index"
  [colorList]="coloredYarnSet"
  [showDetailsOnClick]="false"
  (colorListSelected)="showColoredYarnSetDetails($event, index)"
  [maximumCreelPositionsToShow]="8"
  [startDent]="getStartDent(index)"
/>
